"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEvidenceTableToolbar = void 0;
const react_1 = __importStar(require("react"));
const ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup/ButtonGroup"));
const ChevronLeft_1 = __importDefault(require("@material-ui/icons/ChevronLeft"));
const ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
const detail_toolbar_button_1 = require("../../detail/detail-toolbar-button");
const react_intl_1 = require("react-intl");
function useEvidenceTableToolbar({ tableRef, }) {
    const BeforeToolbar = react_1.useMemo(() => (react_1.default.createElement(ButtonGroup_1.default, { size: "small", variant: "outlined", "aria-label": "Outlined button group" },
        react_1.default.createElement(detail_toolbar_button_1.DetailToolbarButton, { label: react_1.default.createElement(ChevronLeft_1.default, null), tooltip: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_TOOLBAR_TOOLTIP_PREVIOUS", defaultMessage: "Zobrazit p\u0159edchoz\u00ED z\u00E1znam" }), onClick: () => {
                var _a;
                (_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.setPrevRowActive();
            } }),
        react_1.default.createElement(detail_toolbar_button_1.DetailToolbarButton, { label: react_1.default.createElement(ChevronRight_1.default, null), tooltip: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_TOOLBAR_TOOLTIP_NEXT", defaultMessage: "Zobrazit nadchazej\u00EDc\u00ED z\u00E1znam" }), onClick: () => {
                var _a;
                (_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.setNextRowActive();
            } }))), [tableRef]);
    return { BeforeToolbar };
}
exports.useEvidenceTableToolbar = useEvidenceTableToolbar;
//# sourceMappingURL=toolbar-hook.js.map